import Checkbox from "../../Checkbox";
import { useDocumentContext } from "../context";

interface Props {
    name: string;
    value: string | { url: string; lang: string }[];
    containerClassName?: string;
}

const DocumentCheckbox = ({ value, name, containerClassName }: Props) => {
    const { selectedDocumentURLs, setSelectedDocumentURLs } =
        useDocumentContext();

    const isSelected =
        typeof value === "string"
            ? selectedDocumentURLs.some((x) => x.value === value)
            : selectedDocumentURLs.filter((x) =>
                  value.map((x) => x.url).includes(x.value),
              ).length > 0;

    const toggleSelection = () => {
        if (typeof value === "string") {
            setSelectedDocumentURLs(
                isSelected
                    ? selectedDocumentURLs.filter((x) => x.value !== value)
                    : [...selectedDocumentURLs, { value, name }],
            );
        } else {
            setSelectedDocumentURLs(
                isSelected
                    ? selectedDocumentURLs.filter(
                          (x) => !value.map((y) => y.url).includes(x.value),
                      )
                    : [
                          ...selectedDocumentURLs,
                          ...value.map((x) => ({
                              name: `${name} (${x.lang})`,
                              value: x.url,
                          })),
                      ],
            );
        }
    };

    return (
        <Checkbox
            label=""
            value={value}
            inputContainerClassName="h-4"
            selected={isSelected}
            containerClassName={containerClassName}
            onChange={toggleSelection}
            labelClassName="text-sm"
        />
    );
};

export default DocumentCheckbox;
